import { FormikProvider, useFormik } from 'formik';
import * as yup from 'yup';
import { useCreateRegisterMutation } from '@/modules/admin-dashboard/queries/registers.ts';
import {
  BaseModalProps,
  Button,
  ModalContentWrapper,
  ModalContentWrapperProps,
  TextInputField,
} from 'ui';
import { CreateRegisterResponse } from 'compliance-api';

const validationSchema = yup.object({
  name: yup.string().max(100).required('Please write some name'),
});

const initialValues = {
  name: '',
};

interface CreateRegisterModalProps extends BaseModalProps {
  onSuccess?: (res: CreateRegisterResponse) => void;
  wrapperClasses?: ModalContentWrapperProps['classes'];
}

const CreateRegisterModal = ({
  open,
  onClose,
  wrapperClasses,
  onSuccess,
}: CreateRegisterModalProps) => {
  const formik = useFormik({
    initialValues,
    validateOnBlur: false,
    validateOnChange: false,
    validateOnMount: false,
    validationSchema,
    onSubmit: async values => {
      const res = await createRegister(values);
      onSuccess && onSuccess(res);
      onClose();
    },
  });

  const { mutateAsync: createRegister, isLoading } = useCreateRegisterMutation(formik.setErrors);
  return (
    <ModalContentWrapper title="New label" open={open} onClose={onClose} classes={wrapperClasses}>
      <FormikProvider value={formik}>
        <form className="w-full flex flex-col items-center gap-4" onClick={e => e.preventDefault()}>
          <TextInputField name="name" label="tag name" placeholder="Some name..." />
          <Button type="submit" onClick={formik.submitForm} loading={isLoading}>
            Create label
          </Button>
        </form>
      </FormikProvider>
    </ModalContentWrapper>
  );
};

export default CreateRegisterModal;
